import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import aboutImg1 from "../assets/about_1.png"; // replace with actual image path
import aboutImg2 from "../assets/about_2.png"; // replace with actual image path
import "./AboutUs.css";

export default function AboutUs() {
  return (
    <section className="py-5 bg-white">
      <div className="container">
        {/* Title */}
        <div className="text-center mb-4">
          <h2 className="fw-bold">About Us</h2>
          <h5 className="text-warning">Ride Anytime, Anywhere</h5>
        </div>

        {/* First row */}
        <div className="row align-items-center mb-5 about-text">
          <div className="col-lg-8">
            <p className="mb-0">
              At <strong>Thaani</strong>, we are redefining urban mobility with
              safe, reliable, and affordable taxi and transport services.
              Whether you need a quick auto ride, a city taxi, or parcel
              delivery, we ensure a smooth, timely, and professional experience
              every time. With a strong network of trained drivers,
              well-maintained vehicles, and 24/7 customer support, we serve
              thousands of happy customers across multiple cities. Our services
              are accessible through Mobile Apps, WhatsApp, Kiosk Systems, and
              Manual Booking designed to make transportation as easy as sending
              a message.
            </p>
          </div>
          <div className="col-lg-4 text-center mt-4 mt-lg-0">
            <img
              src={aboutImg1}
              alt="Team illustration"
              className="img-fluid"
            />
          </div>
        </div>

        {/* Second row */}
        <div className="row align-items-center flex-lg-row-reverse about-text">
          <div className="col-lg-8">
            <p className="mb-0">
              We're not just growing our fleet—we're growing our family. Through
              our franchise model, we empower local entrepreneurs to build
              successful businesses under a trusted brand. By offering full
              operational support, training, and advanced technology, we help
              our franchise partners deliver top-notch service in their regions.
              Whether you're a customer or a business partner, Thaani is your
              trusted ride everywhere, every time.
            </p>
          </div>
          <div className="col-lg-4 text-center mt-4 mt-lg-0">
            <img
              src={aboutImg2}
              alt="Customer satisfaction"
              className="img-fluid"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
